import React from "react";
import Page from "components/Page";
import { Props } from "./DocumentCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const DocumentCustomTypes = lazyWithRetry(() =>
  import("./DocumentCustomTypes")
);

export default (props: Props) => (
  <Page>
    <DocumentCustomTypes {...props} />
  </Page>
);
